import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Observable, lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilsService } from './utils.service';

export interface WalletPassDownload {
  configured: boolean;
  serial?: string;
  pass_base64?: string;
  detail?: string;
}

@Injectable({ providedIn: 'root' })
export class WalletPassService {
  constructor(private http: HttpClient, private utils: UtilsService) {}

  download(): Observable<WalletPassDownload> {
    const url =
      this.utils.getUrl('rest:wallet-pass-download') ||
      environment.apiUrl + 'api/v1/wallet-pass/download/';
    return this.http.get<WalletPassDownload>(url);
  }

  async addToWallet(): Promise<void> {
    let resp: WalletPassDownload;
    try {
      resp = await lastValueFrom(this.download());
    } catch (error) {
      const http = error as HttpErrorResponse;
      throw new Error(
        http?.error?.detail || http?.message || 'Could not download the Wallet pass.'
      );
    }
    if (!resp?.configured || !resp.pass_base64) {
      throw new Error(resp?.detail || 'Apple Wallet is not configured yet.');
    }

    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      const { CapacitorPassToWallet } = await import('@belongnet/capacitor-pass-to-wallet');
      await CapacitorPassToWallet.addToWallet({ base64: resp.pass_base64 });
      return;
    }

    const bytes = Uint8Array.from(atob(resp.pass_base64), (c) => c.charCodeAt(0));
    const blob = new Blob([bytes], { type: 'application/vnd.apple.pkpass' });
    const href = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = 'activity8.pkpass';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(href);
  }
}
